jQuery(function ($) {
	var pos = 0;
	$(window).on('scroll', function(){
		if($(this).scrollTop() < pos ){
			//上スクロール時ヘッダーのhideClassを削除
			$('#masthead').removeClass('hideClass');
		}else{
			//下スクロール時ヘッダーにhideClassを追加
			$('#masthead').addClass('hideClass');
		}
		pos = $(this).scrollTop();
	});

	  // PC - ドロップメニュー
		if (window.matchMedia('(min-width: 993px)').matches) {
			$('.primary-menu').children('.menu-item').hover(function(){
				$(this).addClass('active');
				$("ul:not(:animated)",this).fadeIn(400); //アニメーションの途中にアニメーションを実行しない
			}, function(){
				$(this).removeClass('active');
				$("ul.sub-menu",this).fadeOut(300);
			});
		}


  // SP - メインメニュー
  $('.site-nav-toggle').on("click", function(){
		$('.site-navi-wrap').fadeToggle(300);
		if( $(this).hasClass('open') ) {
			$(this).removeClass('open');
			$('.toggle-menu').text('MENU');
		} else {
			$(this).addClass('open');
			$('.toggle-menu').text('CLOSE');
		}
  });

  $('.sp-navi-close').on("click", function(){
		$('.site-navi-wrap').fadeToggle(300);
		if( $('.site-nav-toggle').hasClass('open') ) {
			$('.site-nav-toggle').removeClass('open');
		} else {
			$('.site-nav-toggle').addClass('open');
		}
  })

});
